import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "label PingFangSC-Medium" }
const _hoisted_3 = ["src"]

import { computed, ref, watch } from 'vue'
import {
  PRODUCT_CATEGORY,
  ProductCategoryConfig,
  ProductCategoryValue
} from '@/data/const'
import useSelect from '@/hooks/use-select'
import {
  namedImages,
  useCameraFrameStore,
  useConfAndQueryStore,
  useLayoutStore
} from '@/store'
import { storeToRefs } from 'pinia'
import useAlert from '@/hooks/use-alert'
import { throttle } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryFilter',
  setup(__props) {

const layoutStore = useLayoutStore()
const { gotoAllWorks, showManualLoading } = layoutStore
const { hasManualLoading } = storeToRefs(layoutStore)
const cameraFrameStore = useCameraFrameStore()
const { isDefaultCameraActive, isCameraLoading } = storeToRefs(cameraFrameStore)
const { hasAlertShown } = useAlert()
const active = ref(false)
const categories = ref([
  PRODUCT_CATEGORY.RING,
  PRODUCT_CATEGORY.EARRING,
  PRODUCT_CATEGORY.BRACELET,
  PRODUCT_CATEGORY.WATCH
])

const { selectCategory } = useSelect()
const { report } = useConfAndQueryStore()

const onFilterItemClick = throttle(
  async (category: Omit<ProductCategoryConfig, 'kv'>) => {
    report(category.actionNumberOfAll)
    await showManualLoading()
    selectCategory(
      category.value as ProductCategoryValue,
      ['allworks', category.value.toLowerCase()].join('$')
    )
    gotoAllWorks(true)
  }
)

const hidden = computed(() => {
  return isCameraLoading.value || hasManualLoading.value || hasAlertShown.value
})

const visible = computed(() => {
  return isDefaultCameraActive.value && !hidden.value
})

const timer = ref<number>()
watch(
  visible,
  v => {
    clearTimeout(timer.value)
    timer.value = setTimeout(() => {
      active.value = v
    }, 300)
  },
  {
    immediate: true
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-category-filter flex-column-center font-14", { active: active.value }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["c-category-item flex-center-between", `c-category-item-${index}`]),
        style: _normalizeStyle(`--i:${index}`),
        key: category.value,
        onClick: () => _unref(onFilterItemClick)(category)
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(category.label), 1),
        _createElementVNode("img", {
          class: "arrow",
          src: _unref(namedImages).icon_arrow_right
        }, null, 8, _hoisted_3)
      ], 14, _hoisted_1))
    }), 128))
  ], 2))
}
}

})